
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import config from '../../../config'
import Header from '../../Header';
import Footer from '../../Pages/Footer';
import Connectwallet from '../Login/Connect_wallet';
import Google from '../../Pages/Presale/IconBox/Google'
import Thanks from '../Login/Thanks'
// import Selectmethod from './Selectmethod';
import Selectmethod from '../Login/Selectmethod';
import Qrcode from '../Login/Qrcode';
import '../../Pages/css/walletform.css';
import { Container, Row, Col, Card, Button, Form, InputGroup } from 'react-bootstrap';
import * as ACTIONTYPES from '../../../redux/actionTypes'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Spin } from 'antd';
import { ERROR, Success, Warning } from '../../../utils/errors';
import { userlogin } from '../../../services/apiServices';
import { useDispatch } from 'react-redux';
import { FaRegEye } from "react-icons/fa";

const LoadingPopup = () => {
    return (
        <div className="loading-popup-container">
            <div className="loading-popup">
                <p>Please wait</p>
                <h1>Loggin in . . .</h1>
            </div>
        </div>
    );
};

const Walletform = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showLoading, setShowLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [passwordicon, setPasswordicon] = useState(0);

    const submitForm = async (values) => {
        setShowLoading(true)

        const payload = {
            "emailAddress": values.userName,
            "password": values.password
        }
        try {

            const { data: response } = await userlogin(payload)
            setShowLoading(false)
            if (response.status) {
                response.data.isLogin = true;
                dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
                dispatch({ type: ACTIONTYPES.USERLOGIN, payload: response.data, token: response?.data?.accessToken });
                // Success(response.message)
                navigate(`${config.baseurl}`);
            } else {
                Warning(response.message)
            }
        } catch (error) {
            setShowLoading(false)
            console.log('error', error)
            ERROR("Invalid email or password")
        }
    }


    return (
        <>
            {/* <Header /> */}

            <section className="login-section">
                <div className="login-container">
                    <Container fluid className='px-0'>
                        <Row className="justify-content-center">
                            <Col lg={12}>
                                <Row className=''>
                                    <Col lg={5} className=''>
                                        <div className="login-form">
                                            <div className="">
                                                <img
                                                    src="assets/images/login/coinsbackImg.svg"
                                                    alt="logo" className='coinsbackImg'
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={7} className=''>
                                        <Spin spinning={showLoading} >
                                            {/* <div className="loginDiv" style={{ minHeight: "368px" }}> */}
                                            <div className="loginDiv">
                                                <Row>
                                                    <Col lg={7} className='mx-auto'>
                                                        <div className='form_content'>
                                                            <Form >
                                                                <div className='formDiv'>
                                                                    <div>
                                                                        <img src="assets/images/walletformImg.png" className="emailconfirmImg" />
                                                                    </div>
                                                                    <div className='text-center formheadbox'>
                                                                        <h1 className='text-primary fw-bold mb-1'>Connect Your Wallet</h1>
                                                                        <p className=''> <Link className=' text-primary' to={`${config.baseurl}signup`}>Remind me later</Link></p>
                                                                        {/* <Button variant='default' className='px-4 bg-transparent border border-secondary'><Google className="me-2" />&nbsp;&nbsp;Sign up with Google</Button> */}
                                                                    </div>
                                                                    <div className='text-center mt-3'>
                                                                        <Button variant='custombtn2' className='py-2 px-5 fw-bold'>
                                                                            Connect wallet
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </Form>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Spin>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>



                </div>


            </section>

            {/* <Footer /> */}
            {isLoading && <LoadingPopup />}

        </>
    )
}

export default Walletform;
